<template>
  <div class="mainContent grid">
    <div class="page-block u-16">
      <div class="grid between u-16">
        <div class="title-page">
          Интеграция с УралСиб (Корона)
        </div>
      </div>
    </div>
    <div class="page-block cross-center u-16">
      <div class="block">
        <div class="grid-content">
          <div class="input-w300">
            <b-field label="Выберите терминал УралСиб">
              <b-select
                  placeholder="Терминал"
                  v-model="selectedTerminal">
                <option
                    v-for="terminal in uralsibTerminals"
                    :key="terminal.name"
                    :value="terminal.name"
                >{{terminal.human_name}}</option>
              </b-select>
            </b-field>
          </div>
          <div class="input-w300" style="margin-top: 12px;">
            <b-field label="Код активации">
              <b-input v-model="terminalCode"></b-input>
            </b-field>
          </div>
          <div class="u-16">
            <el-button
              style="margin-top: 12px;"
              @click="authTerminal"
              :disabled="!terminalCode || !selectedTerminal"
            >Активировать</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: "UralsibAuth",
  data() {
    return {
      axiosInstance: null,
      selectedTerminal: null,
      terminalCode: null,
      proxy: '',
      userAgent: ''
    }
  },
  methods: {
    resetForm() {
      this.selectedTerminal = null
      this.terminalCode = null
    },
    authTerminal() {
      const h = this.$createElement

      this.axiosInstance.post('/activate', {
        terminalKey: this.selectedTerminal,
        code: this.terminalCode,
        proxy: this.proxy,
        userAgent: this.userAgent
      }).then(({data: {description}}) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: teal' }, `${description}`),
          type: 'success'
        })
        this.resetForm()
      }).catch((err) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: warning' }, `Произошла ошибка ${err.response.data.description}`),
          type: 'warning'
        })
      })
    }
  },
  watch: {
    selectedTerminal(n, o) {
      const idx = this.uralsibTerminals.findIndex(t => t.name === n)
      if (idx !== -1) {
        this.proxy = this.uralsibTerminals[idx].proxy
        this.userAgent = this.uralsibTerminals[idx].userAgent
      } else {
        this.proxy = ""
        this.userAgent = ""
      }
    }
  },
  computed: {
    ...mapGetters([
      "terminalList",
      "processingList"
    ]),
    uralsibTerminals() {
      if (!this.uralsibProcessing) {
        return []
      } else {
        return this.terminalList.filter(terminal => terminal.processing_id === this.uralsibProcessing.id)
      }
    },
    uralsibProcessing() {
      if (this.processingList.length < 1) {
        return null
      } else {
        return this.processingList.filter(processing => processing.name.toLowerCase().includes('uralsib'))[0]
      }
    }
  },
  beforeMount() {
    this.$store.dispatch("getMerchant");
    this.$store.dispatch("getTerminal");
    this.$store.dispatch("getProcessing");

    this.axiosInstance = axios.create({
      baseURL: '/api/uralsib',
      headers: {
        'Authorization-Token': localStorage.getItem('Authorization-Token')
      }
    })
  }
}
</script>

<style scoped>

</style>
